import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { CertificationsStoreContext } from './context/StoreContext'
import { CertificationsStoreProviderProps } from './interface'
import { createCertificationsStore } from './store/createStore'
import { CertificationsStoreUpdater } from './StoreUpdater'

export const CertificationManagePovider = ({
  value,
  onChange,
  children
}: PropsWithChildren<CertificationsStoreProviderProps>) => {
  const store = useCreation(() => createCertificationsStore(), [])

  return (
    <CertificationsStoreContext value={store}>
      <CertificationsStoreUpdater value={value} onChange={onChange} />
      {children}
    </CertificationsStoreContext>
  )
}
